import type { SerializeFrom } from '@remix-run/server-runtime'

import type { CartFull } from '~/models/cart.server'
import invariant from '~/utils/invariant'

import { useMatchesData } from './use-matches-data'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isSerializedCart(cart: any): cart is SerializeFrom<CartFull> {
  return (
    cart &&
    typeof cart === 'object' &&
    typeof cart.cartLines === 'object' &&
    typeof cart.createdAt === 'string'
  )
}

export function useOptionalCart(): SerializeFrom<CartFull> | undefined {
  const data = useMatchesData('routes/__shop')
  if (!data || !isSerializedCart(data.cart)) {
    return undefined
  }

  return data.cart
}

export function useCart(): SerializeFrom<CartFull> {
  const maybeCart = useOptionalCart()
  invariant(
    maybeCart,
    'No cart found in shop loader, but cart is required by useCart'
  )
  return maybeCart
}
